import { useState, useEffect } from "react";
import {
  Card,
  Select,
  MenuItem,
  Typography,
  Box,
  FormControl,
} from "@mui/material";
import { useMediaQuery } from "@mui/material";

const ProductList = () => {
  const [products, setProducts] = useState([]);
  const [productCount, setProductCount] = useState(0);
  const [selectedCompany, setSelectedCompany] = useState("");
  const [companies, setCompanies] = useState({});

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch("https://enzo-matr.onrender.com/api/products");
        if (!response.ok) {
          throw new Error("Failed to fetch products");
        }
        const data = await response.json();

        // Group products by company
        const groupedCompanies = data.reduce((acc, product) => {
          if (!acc[product.company]) {
            acc[product.company] = [];
          }
          acc[product.company].push({ name: product.name, price: product.price });
          return acc;
        }, {});

        setCompanies(groupedCompanies);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchProducts();
  }, []);

  const handleCompanyChange = (event) => {
    const company = event.target.value;
    setSelectedCompany(company);
    if (companies[company]) {
      setProducts(companies[company]);
      setProductCount(companies[company].length);
    } else {
      setProducts([]);
      setProductCount(0);
    }
  };

  const isMobile = useMediaQuery("(max-width:600px)");
  const isTab = useMediaQuery("(max-width:1024px)");
  const isMobileOrTab = isMobile || isTab;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: isMobileOrTab ? "center" : "flex-end",
        height: isMobileOrTab ? "auto" : "475px",
        mt: isMobileOrTab? -4 : 0.2,
        ml: isMobileOrTab ? 3 : 0,
        fontFamily: "Montserrat, sans-serif",
        width: isMobileOrTab ? "95%" : "auto",
      }}
    >
      <Card
        sx={{
          width: isMobileOrTab ? "100%" : 450,
          textAlign: "center",
          boxShadow: 3,
          borderRadius: "8px",
          p: 2,
          fontFamily: "Montserrat, sans-serif",
          minHeight: isMobileOrTab ? "auto" : "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Heading */}
        <Typography
          variant="h6"
          sx={{ mb: 2, fontWeight: "bold", fontSize: "21px", fontFamily: "'Canada Serif', serif" }}
        >
          Select Company name to View All their Products
        </Typography>

        {/* Dropdown */}
        <FormControl fullWidth sx={{ mb: 2 }}>
          <Select
            value={selectedCompany}
            onChange={handleCompanyChange}
            displayEmpty
            sx={{
              backgroundColor: "#fdb913",
              fontWeight: "bold",
              borderRadius: "5px",
              height: "40px", fontFamily: "Montserrat, sans-serif",
              color: "black",
            }}
          >
            <MenuItem value="" disabled>
              <b>Select Name</b>
            </MenuItem>
            {Object.keys(companies).map((company) => (
              <MenuItem key={company} value={company}>
                {company}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Space for product list with scrolling */}
        <Box sx={{ flexGrow: 1, minHeight: "282px", maxHeight: "300px", overflowY: "auto" }}>
          {products.length > 0 && (
            <Box
              sx={{
                border: "1px solid #ddd",
                borderRadius: "5px",
              }}
            >
              {products.map((product, index) => (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    py: 1,
                    px: 2,
                    borderBottom: index !== products.length - 1 ? "1px solid #ddd" : "none",
                  }}
                >
                  <Typography sx={{ fontSize: "14px", fontFamily: "Montserrat, sans-serif" }}>{product.name}</Typography>
                  <Typography sx={{ fontSize: "14px", fontFamily: "Montserrat, sans-serif", fontWeight: "bold" }}>
                    Rs.{product.price}
                  </Typography>
                </Box>
              ))}
            </Box>
          )}
        </Box>

        {/* Product Count at Bottom */}
        <Box
          sx={{
            mt: "auto",
            background: "black",
            color: "white",
            p: 1,
            borderRadius: 1,
            fontWeight: "bold",
            fontSize: "14px",
            textAlign: "center", fontFamily: "Montserrat, sans-serif",
          }}
        >
          Product Count: {productCount}
        </Box>
      </Card>
    </Box>
  );
};

export default ProductList;
